import { buildCognitoLogoutUrl } from './build-cognito-logout-url';

// A plain object, not a bare function export: `window.location` can't be shadowed in a real
// browser (its own properties are unforgeable), and a bare export is a frozen ESM binding either
// way — this gives the sign-out story something it can actually spy on.
export const cognitoLogoutRedirect = {
    perform: () => {
        // Clearing our cookie doesn't end Cognito's hosted-UI session — without this redirect,
        // "Sign in with Google" walks straight back in with no prompt.
        window.location.href = buildCognitoLogoutUrl({
            domain: import.meta.env.VITE_ADMIN_AUTH_DOMAIN,
            clientId: import.meta.env.VITE_ADMIN_AUTH_CLIENT_ID,
            origin: window.location.origin,
        });
    },
};
